import { FC } from 'react';
import { TextField, CloseIcon, SearchIcon, InputAdornment, ArrowBackIosIcon } from '../uiLibraryImports';
import { useTranslationContext } from '../contexts/translationContext';
import { SearchProps } from './searchTypes';
import styles from './search.module.scss';

const Search: FC<SearchProps> = (props: SearchProps) => {
    const { onReset, onChange, value, arrowIcon, noBackground } = props;
    const { translate } = useTranslationContext();
    return (
        <TextField
            inputProps={{ 'data-testid': 'search' }}
            value={value}
            className={noBackground ? styles['search-no-background'] : styles.search}
            placeholder={translate('Search')}
            onChange={e => onChange(e.target.value)}
            InputProps={{
                className: styles.text,
                disableUnderline: true,
                startAdornment: (
                    <InputAdornment position="start">
                        {arrowIcon ? (
                            <ArrowBackIosIcon data-testid="search-icon" className={styles['search-icon']} />
                        ) : (
                            <SearchIcon data-testid="search-icon" className={styles['search-icon']} />
                        )}
                    </InputAdornment>
                ),
                ...(onReset && {
                    endAdornment: (
                        <InputAdornment position="end">
                            <CloseIcon data-testid="reset-icon" onClick={() => onReset('')} className={styles.reset} />
                        </InputAdornment>
                    )
                })
            }}
        />
    );
};

export default Search;
